"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HOUR_TO_RUN_SCHEDULED_PAYMENT_SUBSCRIBER_NYC_TIME = exports.ScheduledOneTimePaymentFundingType = exports.ScheduledOneTimePaymentStatus = void 0;
var ScheduledOneTimePaymentStatus;
(function (ScheduledOneTimePaymentStatus) {
    ScheduledOneTimePaymentStatus["Scheduled"] = "Scheduled";
    ScheduledOneTimePaymentStatus["Completed"] = "Completed";
    ScheduledOneTimePaymentStatus["Failed"] = "Failed";
    ScheduledOneTimePaymentStatus["Canceled"] = "Canceled";
})(ScheduledOneTimePaymentStatus || (exports.ScheduledOneTimePaymentStatus = ScheduledOneTimePaymentStatus = {}));
var ScheduledOneTimePaymentFundingType;
(function (ScheduledOneTimePaymentFundingType) {
    ScheduledOneTimePaymentFundingType["EXTERNAL_BANK_ACCOUNT"] = "EXTERNAL_BANK_ACCOUNT";
    ScheduledOneTimePaymentFundingType["ADD_NEW_BANK_ACCOUNT"] = "ADD_NEW_BANK_ACCOUNT";
    ScheduledOneTimePaymentFundingType["DEBIT_CARD"] = "DEBIT_CARD";
})(ScheduledOneTimePaymentFundingType || (exports.ScheduledOneTimePaymentFundingType = ScheduledOneTimePaymentFundingType = {}));
exports.HOUR_TO_RUN_SCHEDULED_PAYMENT_SUBSCRIBER_NYC_TIME = 10;
